/**
 * Canonical dashboard widget registry — IDs are stored in role permissions on the server.
 * Grouped by business area; maps to user-facing dashboard requirements.
 */
export const DASHBOARD_WIDGETS = [
  // Enquiry & pipeline KPIs (CEO / Salesforce)
  { id: 'kpi-leads', label: 'Leads', category: 'Enquiries' },
  { id: 'kpi-opportunities', label: 'Opportunities', category: 'Enquiries' },
  { id: 'kpi-properties-booked', label: 'Properties Booked', category: 'Bookings' },
  { id: 'kpi-closed-won', label: 'Closed Won', category: 'Outcomes' },
  { id: 'kpi-closed-lost', label: 'Closed Lost', category: 'Outcomes' },
  { id: 'kpi-revenue', label: 'Revenue', category: 'Financial' },
  { id: 'kpi-avg-booking-value', label: 'Avg Booking Value', category: 'Financial' },
  { id: 'kpi-new-listings', label: 'New Listings (Website)', category: 'Listings' },
  { id: 'delistings', label: 'De-listings', category: 'Listings' },

  // Conversion & account managers
  { id: 'conversion-win-loss', label: 'Conversion Rate (Won / Lost)', category: 'Conversion' },
  { id: 'conversion-by-account-manager', label: 'Conversion Rate per Account Manager', category: 'Conversion' },
  { id: 'account-manager-distribution', label: 'Account Manager Distribution', category: 'Team' },
  { id: 'lead-categories', label: 'Lead Categories', category: 'Enquiries' },
  { id: 'opportunity-sectors', label: 'Opportunity Sectors', category: 'Enquiries' },

  // Pipeline
  { id: 'pipeline', label: 'Enquiry Pipeline', category: 'Pipeline' },
  { id: 'published-property-posts', label: 'Published Property Posts', category: 'Listings' },

  // Closed deals breakdown
  { id: 'closed-won-by-sector', label: 'Closed Won by Sector', category: 'Outcomes' },
  { id: 'closed-won-by-state', label: 'Closed Won by State', category: 'Outcomes' },
  { id: 'closed-lost-reasons', label: 'Closed Lost + Reason', category: 'Outcomes' },
  { id: 'closed-lost-by-state', label: 'Closed Lost by State', category: 'Outcomes' },
  { id: 'conversion-by-sector', label: 'Conversion by Sector', category: 'Conversion' },
  { id: 'avg-booking-by-sector', label: 'Avg Booking Value by Sector', category: 'Financial' },

  // BDM financial & performance
  { id: 'kpi-profit', label: 'Profit KPI', category: 'Financial' },
  { id: 'kpi-locations', label: 'Active Locations KPI', category: 'Locations' },
  { id: 'kpi-bookings', label: 'Bookings KPI', category: 'Bookings' },
  { id: 'filters', label: 'Dashboard Filters', category: 'General' },
  { id: 'fy-goal-analysis', label: 'Financial Year Goal Analysis', category: 'Financial' },
  { id: 'enquiries-yoy', label: 'Enquiries Year-over-Year', category: 'Enquiries' },
  { id: 'top-clients-revenue', label: 'Top Clients by Revenue & Profit', category: 'Revenue' },
  { id: 'top-locations-performance', label: 'Top 20 Locations by Performance', category: 'Locations' },
  { id: 'most-booked-properties-fy', label: 'Most Booked Properties (FY)', category: 'Locations' },
  { id: 'most-profitable-locations-fy', label: 'Most Profitable Locations (FY)', category: 'Locations' },
  { id: 'booking-trends', label: 'Booking Trends', category: 'Bookings' },
  { id: 'expanded-booking-trends', label: 'Expanded Booking Trends', category: 'Bookings' },
  { id: 'enquiry-predictions', label: 'Predicted Client Enquiries', category: 'Predictions' },
  { id: 'popular-designs-all-time', label: 'Popular Designs (Selected Period)', category: 'Design' },
  { id: 'popular-designs-monthly-fy', label: 'Monthly Design Trends (FY)', category: 'Design' },
  { id: 'client-fy-summary', label: 'Client Financial Year Summary', category: 'Financial' },
];

export const ALL_WIDGET_IDS = DASHBOARD_WIDGETS.map((w) => w.id);

/** @deprecated Use ALL_WIDGET_IDS — kept for migrations referencing old IDs */
export const LEGACY_WIDGET_ID_MAP = {
  'account-manager-workload': 'account-manager-distribution',
  'enquiry-pipeline': 'pipeline',
  'win-loss-ratio': 'conversion-win-loss',
  'top-location-performance': 'top-locations-performance',
  'popular-designs': 'popular-designs-all-time',
};
